import { Filter } from 'components/FilterAutocomplete/types/filter';

export const filterValues: Filter[] = [
  {
    key: 'environment',
    label: 'Environment',
  },
  {
    key: 'publisher',
    label: 'Publisher',
  },
  {
    key: 'formatSize',
    label: 'Format Size',
  },
  {
    key: 'status',
    label: 'Status',
  },
  {
    key: 'resolution',
    label: 'Resolution',
  },
];

export const filterFrameIds: Filter[] = [
  {
    key: 'frameId',
    label: 'Frame ID',
  },
];
